// Alphanumeric, spaces and dashes
export const APHANUM_SPACE_DASH_REGEX = /^[a-zA-Z0-9\s-]*$/;

// Alphanumeric, spaces, dots, % and dashes
export const APHANUM_SPACE_DASH_DOT_REGEX = /^[a-zA-Z0-9\s.%-]*$/;

export const WHITESPACE_REGEX = /\s+/g;

export const WHITESPACE = ' ';
